import { render } from "./BuyerDetails.vue?vue&type=template&id=069fb0c8&scoped=true&lang=pug"
import script from "./BuyerDetails.vue?vue&type=script&lang=ts"
export * from "./BuyerDetails.vue?vue&type=script&lang=ts"

import "./BuyerDetails.vue?vue&type=style&index=0&id=069fb0c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-069fb0c8"

export default script